export default {
  beforeRouteLeave(to, from, next) {
    if (
      this.cancel ||
      this.formIsPristineCommon(this.form, this.cloneForm) ||
      to.name == "criticism endorsement policy"
    )
      next();
    this.modalCancelEndoserment = true;
    this.nextRoute = to;
  },
  data: () => ({
    modalCancelEndoserment: false,
    nextRoute: null,
    cancel: false
  }),
  methods: {
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelEndoserment = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  }
};
